import { useContext, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { LocationAddress, Tooltip } from '@components';
import { GlobalContext } from '@contexts';
import { isPrimarySite } from '@helpers';
import {
  Edit2Icon,
  ExternalLinkIcon,
  MonitorIcon,
  MoreHorizontalIcon,
} from '@svgs';

import './WebsiteRow.scss';

const Tag = ({ children, tooltip }) => {
  return (
    <Tooltip tooltip={tooltip}>
      <span className="sb-row-tag">{children}</span>
    </Tooltip>
  );
};

const WebsiteRow = ({ locationsByID, website }) => {
  const { t, i18n } = useTranslation();
  const globals = useContext(GlobalContext);

  // menu activation
  const dropdownMenu = useRef(null);
  const [showDropdownMenu, setShowDropdownMenu] = useState(false);
  const closeOpenMenus = (e) => {
    if (showDropdownMenu && !dropdownMenu.current?.contains(e.target)) {
      setShowDropdownMenu(false);
    }
  };
  document.addEventListener('mousedown', closeOpenMenus);

  return (
    <div className="sb-row-item">
      <div className="sb-row--website-display-url">
        <p>
          {/* redirecting to Interstitial Page to decide route  */}
          <Link to={`/dashboard/sites/${website.id}`}>
            {website.display_url}
          </Link>
        </p>
      </div>
      <div className="sb-row--website-location">
        {isPrimarySite(website) && locationsByID && (
          <p>
            Primary website ({Object.keys(locationsByID).length} location
            {Object.keys(locationsByID).length != 1 ? 's' : ''})
          </p>
        )}
        {website.location_ids.length === 1 &&
          locationsByID &&
          locationsByID[website.location_ids[0]] && (
            <p>
              <Link
                to={`/dashboard/projects/${website.business_id}/locations/${website.location_ids[0]}`}
              >
                {locationsByID[website.location_ids[0]].location_name && (
                  <>
                    {locationsByID[website.location_ids[0]].location_name}
                    <br />
                  </>
                )}
                <span>
                  <LocationAddress
                    location={locationsByID[website.location_ids[0]]}
                  />
                </span>
              </Link>
            </p>
          )}
        {website.location_ids.length > 1 && (
          <p>
            <Link
              to={`/dashboard/projects/${website.business_id}/locations/${website.location_ids[0]}`}
            >
              {website.location_ids.length} locations
            </Link>
          </p>
        )}
        {website.location_ids.length === 1 && !locationsByID && <p>...</p>}
      </div>
      <div className="sb-row--website-tags">
        <p>
          {website.published === false && (
            <Tag tooltip="Site is unpublished, will 404">Unpublished</Tag>
          )}
          {website.has_draft === true && (
            <Tag tooltip="Site has a draft">In Draft</Tag>
          )}
        </p>
      </div>
      <div className="sb-options">
        <button
          className="sb-page-options-menu-trigger sb-options-trigger"
          onClick={() => setShowDropdownMenu(!showDropdownMenu)}
        >
          <MoreHorizontalIcon />
        </button>
        <div
          ref={dropdownMenu}
          className={
            'sb-options-menu ' + (showDropdownMenu ? 'sb-show' : 'sb-hide')
          }
        >
          <div className="sb-options-menu-content">
            <Link
              to={`/dashboard/sites/${website.id}/custom_fields`}
              className="sb-options-item"
            >
              <Edit2Icon />
              {t('Manage content')}
            </Link>
            <a
              href={
                website.published ? website.formatted_url : website.preview_url
              }
              target="_blank"
              className="sb-options-item"
            >
              <MonitorIcon />
              {t('View website')}
            </a>
            {globals.visible.websiteViewPreview && (
              <a
                href={website.preview_url}
                target="_blank"
                className="sb-options-item"
              >
                <ExternalLinkIcon />
                {t('View preview')}
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebsiteRow;
